import { useContext } from 'react'

import { PreviewContext } from '~/contexts/PreviewContext'

const usePreview = () => {
  const context = useContext(PreviewContext)

  if (!context) {
    throw new Error('usePreview must be used within an PreviewProvider')
  }

  return context
}

export default usePreview
